import imgEmpty from '@/assets/images/empty@2x.png';
import imgDelete from '@/assets/images/empty-delete@2x.png';
export default {
  props: {
    title: {
      type: String
    },
    type: {
      type: String,
      default: 'empty'
    }
  },
  components: {},
  data: function data() {
    return {
      images: {
        empty: imgEmpty,
        delete: imgDelete
      }
    };
  },
  computed: {},
  methods: {},
  created: function created() {},
  mounted: function mounted() {},
  beforeUnmount: function beforeUnmount() {},
  watch: {}
};